import React, { Component } from "react";
import HeaderContainer from "COMPONENTS/Header/HeaderContainer";
import { CONFIG, LANGUAGE, USER_ROLES } from "UTILS/Constants";

import ScheduleSession from "COMPONENTS/SessionManagement/ScheduleSession/ScheduleSessionContainer";
import TrailHistory from "COMPONENTS/SessionManagement/TrailHistory/TrailHistoryContainer";
import StartSessionContainer from "COMPONENTS/SessionManagement/StartSession/StartSessionContainer";
import SessionManagementContainer from "COMPONENTS/SessionManagement/SessionManagementContainer";
import PageNotFound from "COMPONENTS/ErrorComponents/PageNotFound";
import WaitingUsersContainer from "COMPONENTS/SessionManagement/WaitingUsers/WaitingUsersContainer";
import CallWaitingContainer from "COMPONENTS/SupportCenter/CallWaiting/CallWaitingContainer";
import store from '@/Redux/store';
import i18n, { replaceTranslationDataToResources, changeLanguage } from '@/Config/i18n';
import { organisationAction } from '@/Config/ActionFactory';
import setLanguageAction from '../CommonComponents/ChangeLanguage/setLanguageAction';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class SessionManagementMainlayout extends Component {

  componentDidMount(){
    this.updateTenantLanguage();
    changeLanguage();
  }

  updateTenantLanguage = () => {
    if (!this.props.gottenWording && !this.props.isWordingGotten) {
      this.getOrgWording();
    } else if (this.props.gottenWording && this.props.isWordingGotten) {
      replaceTranslationDataToResources(this.onSelectChange);
    }
  }

  getOrgWording = () => {
    organisationAction.getOrgWordingUrlAction(store.getState().UserReducer.userDetails.customerId, '').then(
      response_data => {
        replaceTranslationDataToResources(this.onSelectChange);
      }, error => {
      }
    );
  };
  
  onSelectChange = selectedLanguage => {
    this.props.setLanguageAction(selectedLanguage);
  };

  renderComponents = () => {
    switch(this.props.location.pathname) {
      case CONFIG.path.createSession :
        return <SessionManagementContainer {...this.props}/>
      case CONFIG.path.startMeeting:
        return <StartSessionContainer {...this.props}/>
        {/* Comment this for the future purposes */}
      // case CONFIG.path.scheduleMeeting:
      //   return <ScheduleSession {...this.props}/>
      case CONFIG.path.trailHistory:
        return <TrailHistory {...this.props}/>
      case CONFIG.path.waitingUsers:
        return <WaitingUsersContainer {...this.props}/>
      case CONFIG.path.callWaiting:
        return <CallWaitingContainer {...this.props}/>
      default:
        return <PageNotFound />
    }
  }

  render() {
    return (
      <>
        <HeaderContainer history={this.props.history} />
        {this.renderComponents()}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    language: state.LanguageReducer.language,
    gottenWording: state.OrganisationReducer.wordingUrl,
    isWordingGotten: state.OrganisationReducer.isWordingFetched,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      setLanguageAction
    },
    dispatch
  ); 
};

export default connect(mapStateToProps, mapDispatchToProps)(SessionManagementMainlayout);